module.exports = __webpack_public_path__ + "img/cancel.00e7416e.svg";